module.exports = __webpack_public_path__ + "img/home-kpi.24fa8eba.png";